import Chip from '@mui/material/Chip';
import React from 'react';
import {
	DISBURSEMENT_STATE_CHIP__DISCARDED,
	DISBURSEMENT_STATE_CHIP__DRAFT,
	DISBURSEMENT_STATE_CHIP__ERROR,
	DISBURSEMENT_STATE_CHIP__ISSUED,
} from '../data/constants';

interface DisbursementStateChipProps {
	state: 'discarded' | 'draft' | 'issued';
}

const DisbursementStateChip = (props: DisbursementStateChipProps) => {
	const { state } = props;
	switch (state) {
		case 'draft':
			return (
				<Chip
					label={DISBURSEMENT_STATE_CHIP__DRAFT}
					color='neutralWarning'
					variant='filled'
					size='small'
				/>
			);
		case 'issued':
			return (
				<Chip
					label={DISBURSEMENT_STATE_CHIP__ISSUED}
					color='neutralSuccess'
					variant='filled'
					size='small'
				/>
			);
		case 'discarded':
			return (
				<Chip
					label={DISBURSEMENT_STATE_CHIP__DISCARDED}
					color='neutral'
					variant='filled'
					size='small'
				/>
			);
		default:
			return (
				<Chip label={DISBURSEMENT_STATE_CHIP__ERROR} color='neutralError' />
			);
	}
};

export default DisbursementStateChip;
